(ns teamoesterreich.user-mode.wana-help.nokat.checks
  (:require [clojure.string]
            ))




(defn check-wanado? [!actual-user]
  (or
    (get-in @!actual-user [:help :NormEinmalAufgaben])
    (get-in @!actual-user [:help :NormProjekten])
    (get-in @!actual-user [:help :NormLogistik])
    (get-in @!actual-user [:help :NormAdministrativen])
    (get-in @!actual-user [:help :NormRotkreuzVeranstaltungen])
    (get-in @!actual-user [:help :NormCampaigning])
    (get-in @!actual-user [:help :NormHilfsaktivitäten])
    )
  )

(defn check-qualification? [!actual-user]
  (or
    (and (get-in @!actual-user [:languages]) (> (count (get-in @!actual-user [:languages])) 0))
    (not= "" (get-in @!actual-user [:military-service]))
    (not= "" (get-in @!actual-user [:other-qualifications]))
    (not= "" (get-in @!actual-user [:other-licences]))
    (not= "" (get-in @!actual-user [:other-emergency-work]))
    )
  )

(defn check-identity? [!actual-user]
  (:identity-confirmed @!actual-user))

(defn check-profile? [!actual-user]
  (:profile-complete @!actual-user))

(defn check-email? [!actual-user]
  (:email-confirmed @!actual-user))

(defn check-handy? [!actual-user]
  (:hdy-valid @!actual-user))

(defn check-all? [!actual-user]
  (and
    (check-profile? !actual-user)
    (check-email? !actual-user)
    (check-handy? !actual-user)
    (check-wanado? !actual-user)
    )
  )







